<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" title="New OSHA Violation" size="lg" ok-title="Save OSHA Yearly Data" ok-variant="success" :ok-disabled="saving" :cancel-disabled="saving" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="oshaCitationModal" :no-close-on-backdrop="true" scrollable>

            <div v-if="loading" class="text-center">
                <i class="fa fa-circle-o-notch fa-spin"></i> Loading
            </div>
            <template v-else>
                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.citation_type }">Citation Type: <i v-if="!citation.citation_type" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-7">

                        <b-form-select v-model="citation.citation_type" :options="types" :class="{'is-invalid': errors.citation_type}"/>

                        <span v-if="errors.citation_type" class="text-danger">
                            <span v-for="error in errors.citation_type">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.citation_date }">Date: <i v-if="!citation_date" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-7">

                        <date-picker v-model="citation_date" :config="{format: 'MM/DD/YYYY', useCurrent: false, viewMode: 'months'}" :class="{ 'is-invalid': errors.citation_date }" placeholder="Violation Date"></date-picker>

                        <span v-if="errors.citation_date" class="text-danger">
                            <span v-for="error in errors.citation_date">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.citation_details }">Details: <i v-if="!citation.citation_details" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-7">

                        <b-form-textarea v-model="citation.citation_details" placeholder="Describe the Violation details" rows="6" />

                        <span v-if="errors.citation_details" class="text-danger">
                            <span v-for="error in errors.citation_details">{{ error }}</span>
                        </span>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {

            subcontractorId: {
                type: Number,
                default: null,
            },
        },

        data: function() {
            return {
                openModal: false,
                loading: false,
                saving: false,
                errors: {},
                citation: {},
                citation_date: null,
                types: {
                    'Other-Than-Serious': 'Other-Than-Serious',
                    'Serious': 'Serious',
                    'Willful': 'Willful',
                    'Repeat': 'Repeat',
                },
            }
        },

        methods: {

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.citation = {};
                this.errors = {};
                this.citation_date = null;
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveForm();
            },

            showModal(){
                //Show ti
                this.openModal = true;
            },

            setModel(citation){
                this.citation = JSON.parse(JSON.stringify(citation));
                if (this.citation.citation_date)
                {
                    this.citation_date = moment(this.citation.citation_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
                }
            },

            saveForm(){
                //Reset errors
                this.errors = {};

                //Loading
                this.saving = true;

                if (this.citation_date)
                {
                    this.citation.citation_date = moment(this.citation_date, 'MM/DD/YYYY').format('YYYY-MM-DD');
                }

                //Send it
                this.$http
                .post('subcontractors/osha-citation/' + this.subcontractorId, this.citation)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('OSHA Violation Saved');

                    //Emit
                    this.$store.commit('updateCitation', response.data);

                    //Close the modal
                    this.$refs.oshaCitationModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //SEt the height
            //this.$refs.oshaCitationModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

            //Get the resources
            //this.getForm();
        }
    }
</script>